import { ComponentIds, HierarchyUtils, ProductUtils } from '@inter-ikea-core/core';
import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
export class RestrictPulloutInteriorsInDeepCornerAddonFrameValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictPulloutInteriorsInDeepCornerAddonFrameValidation');
        this.restrictedInteriors = [
            {
                interiorsComponent: ComponentIds.DRAWER_COMPONENT_ID,
                interiorName: 'Drawer',
                isRestrictedHoleInHighFrame: (hole) => {
                    return hole < 5 || (hole >= 27 && hole <= 39) || hole > 61;
                },
                isRestrictedHoleInLowLeftFrame: (hole) => {
                    return hole < 5 || (hole >= 24 && hole <= 30) || hole > 50;
                },
                isRestrictedHoleInLowRightFrame: (hole) => {
                    return hole < 5 || (hole >= 25 && hole <= 31) || hole > 50;
                }
            },
            {
                interiorProductType: ProductType.PAX_PULL_OUT_TRAY,
                interiorName: 'Tray',
                isRestrictedHoleInHighFrame: (hole) => {
                    return ((hole >= 2 && hole <= 4) ||
                        (hole >= 31 && hole <= 33) ||
                        (hole >= 37 && hole <= 39) ||
                        (hole >= 66 && hole <= 68));
                },
                isRestrictedHoleInLowLeftFrame: (hole) => {
                    return (hole >= 2 && hole <= 4) || (hole >= 28 && hole <= 30) || hole > 54;
                },
                isRestrictedHoleInLowRightFrame: (hole) => {
                    return (hole >= 2 && hole <= 4) || (hole >= 29 && hole <= 31) || hole > 54;
                }
            }
        ];
        this.coreApi = coreApi;
    }
    failedResult(restrictedInteriorName, productRef) {
        return this.validationFail(`${restrictedInteriorName} is not allowed on the same height as door hinges in corner addon frame: ${productRef}`);
    }
    isEntityRestrictedInterior(entity, restrictedInterior) {
        return ((restrictedInterior.interiorsComponent &&
            entity.hasComponent(restrictedInterior.interiorsComponent)) ||
            (restrictedInterior.interiorProductType &&
                this.coreApi.entities.isProductType(entity, restrictedInterior.interiorProductType)));
    }
    validateCurrentState(entity) {
        return this.validate(entity);
    }
    validateSnap(snapActionCandidate) {
        return this.validate(snapActionCandidate.guestRoot, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        let result = this.validationOK();
        const cornerAddonFrame = snapActionCandidate?.host;
        if (cornerAddonFrame && this.isDeepCornerAddonFrame(cornerAddonFrame)) {
            this.restrictedInteriors.forEach(restrictedInterior => {
                const snapActionCandidateGuest = snapActionCandidate?.guest;
                if (snapActionCandidateGuest) {
                    // Interior
                    if (this.isEntityRestrictedInterior(snapActionCandidateGuest, restrictedInterior)) {
                        const door = HierarchyUtils.descendants(cornerAddonFrame).find(it => it.hasComponent(ComponentIds.DOOR_COMPONENT_ID));
                        if (door &&
                            this.isHoleRestricted(snapActionCandidate?.hostConnector, cornerAddonFrame, door, restrictedInterior)) {
                            result = this.failedResult(restrictedInterior.interiorName, ProductUtils.productRefOrEmptyString(entity));
                        }
                    }
                    // Door
                    if (snapActionCandidateGuest.hasComponent(ComponentIds.DOOR_COMPONENT_ID) ||
                        snapActionCandidateGuest.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID)) {
                        const interiors = HierarchyUtils.descendants(cornerAddonFrame).filter(it => this.isEntityRestrictedInterior(it, restrictedInterior));
                        if (interiors) {
                            interiors.forEach(interior => {
                                const connectorOnHost = interior.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.hostConnector;
                                if (connectorOnHost &&
                                    this.isHoleRestricted(connectorOnHost, cornerAddonFrame, interior, restrictedInterior)) {
                                    result = this.failedResult(restrictedInterior.interiorName, ProductUtils.productRefOrEmptyString(entity));
                                }
                            });
                        }
                    }
                }
            });
        }
        return result;
    }
    isDeepCornerAddonFrame(entity) {
        return (this.coreApi.entities.isProductType(entity, ProductType.PAX_ADD_ON_CORNER_FRAME) &&
            this.getComSizeDepth(entity) === 580);
    }
    isHoleRestricted(pointSeriesSubConnector, cornerAddonFrame, door, restrictedInterior) {
        if (this.getComSizeHeight(cornerAddonFrame) == 2360.0) {
            const validHole = restrictedInterior.isRestrictedHoleInHighFrame(pointSeriesSubConnector.hole);
            return validHole;
        }
        else {
            const doorChildComponent = door.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
            if (doorChildComponent) {
                const hostKey = doorChildComponent.highestPriorityConnection?.hostConnector.key;
                if (hostKey === 'left-door-placement') {
                    return restrictedInterior.isRestrictedHoleInLowLeftFrame(pointSeriesSubConnector.hole);
                }
                else {
                    return restrictedInterior.isRestrictedHoleInLowRightFrame(pointSeriesSubConnector.hole);
                }
            }
        }
        return false;
    }
    getComSizeHeight(entity) {
        const comSize = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        if (comSize == null) {
            /* eslint-disable-next-line no-console */
            console.warn(`Entity ${entity.id} with product ${ProductUtils.productRef(entity)} has no CommunicationSizeComponent. ValetHangerOnCornerAddonFrameValidationRule needs to know the size of the entity`);
        }
        return comSize?.size?.height;
    }
    getComSizeDepth(entity) {
        const comSize = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        if (comSize == null) {
            /* eslint-disable-next-line no-console */
            console.warn(`Entity ${entity.id} with product ${ProductUtils.productRef(entity)} has no CommunicationSizeComponent. ValetHangerOnCornerAddonFrameValidationRule needs to know the size of the entity`);
        }
        return comSize?.size?.depth;
    }
}
//# sourceMappingURL=RestrictPulloutInteriorsInDeepCornerAddonFrameValidation.js.map